export class Constants {
  private static readonly Miliseconds: number = 1000;
  public static readonly BusinessDashboardRefreshInterval: number = 60 * Constants.Miliseconds;
  public static readonly DashboardRefreshInterval: number = 60 * Constants.Miliseconds;
  public static readonly LicenseRefreshInterval: number = 60 * Constants.Miliseconds;
  public static readonly NotificationsRefreshInterval: number = 60 * Constants.Miliseconds;
  public static readonly UpdateInterval: number = 2 * Constants.Miliseconds;
  public static readonly DefaultStartPageUri: string = '';
  public static readonly CompanyMaxSlugLength: number = 45;

  /**
   * Error code the API returns when a company slug is already held by another company. Kept in sync with the
   * constant of the same name in CompanyController; matched on instead of the response message, which is an
   * English sentence aimed at a log.
   */
  public static readonly CompanySlugNotUniqueErrorCode: string = 'CompanySlugNotUnique';

  /**
   * Error code the API returns when a payment action slug is already used by another action of the same
   * company. Kept in sync with the constant of the same name in PaymentActionController; matched on instead of
   * the response message, which is a sentence aimed at a person and will be reworded.
   */
  public static readonly PaymentActionSlugNotUniqueErrorCode: string = 'PaymentActionSlugNotUnique';

  public static readonly PaymentActionMaxSlugLength: number = 45;

  /* Urls */
  public static readonly AccountLoginUrl = 'account/login';
  public static readonly AccountForgotPasswordUrl = 'account/forgot-password';
  public static readonly AccountResetPasswordUrl = 'account/reset-password';
  public static readonly SettingsActivateLicenseUrl = 'settings/activate-license';

  public static readonly DefaultDashboardPageSize: number = 5;
  public static readonly DefaultPageNumber: number = 1;
  public static readonly DefaultPageSize: number = 10;
  public static readonly DefaultMobilePageSize: number = 5;
  public static readonly DefaultTotalRecords: number = 0;
  public static readonly DefaultNotificationPageSize: number = 3;

  /* Upgrade Credit Request Amount */
  public static readonly CreditAmountMinimumValue: number = 50;
  public static readonly CreditAmountMaximumValue: number = 99999;

  /* Payment Request Amount */
  public static readonly AmountMinimumValue: number = 0;
  public static readonly AmountMaximumValue: number = 99999;

  // Default sorting fields

  /* Companies */
  public static readonly Companies_List_DefaultSortField: string = 'Name';
  public static readonly Companies_List_DefaultSortDirectionAscending: boolean = true;

  /* Company Accounts */
  public static readonly CompanyBanks_DefaultSortField: string = 'BankName';
  public static readonly CompanyBanks_DefaultSortDirectionAscending: boolean = true;

  /* Email Messages */
  public static readonly EmailMessages_List_DefaultSortField: string = 'EmailMessageId';
  public static readonly EmailMessages_List_DefaultSortDirectionAscending: boolean = false;

  /* Financial Transactions */
  public static readonly FinancialTransactions_List_DefaultSortField: string = 'CreatedAt';
  public static readonly FinancialTransactions_List_DefaultSortDirectionAscending: boolean = false;

  /* Modules */
  public static readonly Modules_List_DefaultSortField: string = 'ModuleId';
  public static readonly Modules_List_DefaultSortDirectionAscending: boolean = true;

  /* Payment Actions */
  public static readonly PaymentActions_List_DefaultSortField: string = 'Id';
  public static readonly PaymentActions_List_DefaultSortDirectionAscending: boolean = false;

  /* Payment Requests */
  public static readonly PaymentRequests_List_DefaultSortField: string = 'PaymentRequestId';
  public static readonly PaymentRequests_List_DefaultSortDirectionAscending: boolean = false;

  /* Sms Messages */
  public static readonly SmsMessages_List_DefaultSortField: string = 'SmsMessageId';
  public static readonly SmsMessages_List_DefaultSortDirectionAscending: boolean = false;

  /* Audit Logs */
  public static readonly AuditLogs_List_DefaultSortField: string = 'AuditLogId';
  public static readonly AuditLogs_List_DefaultSortDirectionAscending: boolean = false;

  /* Users */
  public static readonly Users_List_DefaultSortField: string = 'UserName';
  public static readonly Users_List_DefaultSortDirectionAscending: boolean = true;

  /* Document Intelligce */
  public static readonly DocumentIntelligence_Models_DefaultSortField: string = "Id";
  public static readonly DocumentIntelligence_Models_DefaultSortDirectionAscending: boolean = true;

  public static readonly DocumentIntelligence_Requests_DefaultSortField: string = "Id";
  public static readonly DocumentIntelligence_Requests_DefaultSortDirectionAscending: boolean = true;

  /* Customer Organizations */
  public static readonly CustomerOrganizations_List_DefaultSortField: string = 'Name';
  public static readonly CustomerOrganizations_List_DefaultSortDirectionAscending: boolean = true;

  /* Bank Transaction Dashboard */
  public static readonly BankTransactionDashboard_List_DefaultSortField: string = 'CompanyId';
  public static readonly BankTransactionDashboard_List_DefaultSortDirectionAscending: boolean = false;
}
